var map = {
	"./main/admin/admin.module": [
		"./src/app/main/admin/admin.module.ts",
		"default~main-admin-admin-module~main-pages-pages-module",
		"main-admin-admin-module"
	],
	"./main/pages/pages.module": [
		"./src/app/main/pages/pages.module.ts",
		"default~main-admin-admin-module~main-pages-pages-module",
		"main-pages-pages-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;